import React, { useState, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import SalesForceTable from '../../../../components/tables/SalesForceTable';

const RSM = () => {
  const location = useLocation();

  // Sample data generator
  const generateSampleData = (count = 30) => {
    const states = [
      'Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Gujarat',
      'Rajasthan', 'Uttar Pradesh', 'West Bengal', 'Telangana', 'Punjab'
    ];
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi',
      'Suresh Yadav', 'Kavita Mehta', 'Arun Kumar', 'Pooja Singh',
      'Deepak Sharma', 'Ritu Agarwal', 'Manoj Tiwari', 'Swati Desai',
      'Sanjay Rao', 'Meera Nair', 'Karan Khanna', 'Divya Saxena'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      id: `RSM${String(i + 1).padStart(4, '0')}`,
      name: names[Math.floor(Math.random() * names.length)],
      mobile: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      state: states[Math.floor(Math.random() * states.length)],
      date: new Date(2020 + Math.floor(Math.random() * 5), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0]
    }));
  };

  // Initialize data with state
  const [salesData, setSalesData] = useState({
    data: generateSampleData(30)
  });

  // Handle data change (add/edit)
  const handleDataChange = (newData) => {
    setSalesData({
      data: newData
    });
  };

  return (
    <Container fluid className="">
      <SalesForceTable
        data={salesData.data}
        salesRole="Regional Manager"
        onDataChange={handleDataChange}
      />
    </Container>
  );
};

export default RSM;

